import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ArchiveTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/passports`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setData(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // Filter for EMC passports and search term
    const filteredData = data.filter(item =>
        item.passport_type.Rule === "EMC" &&
        (searchTerm === "" || (item.passportNumber && item.passportNumber.toLowerCase().includes(searchTerm.toLowerCase())))
    );

    const baseUrl = process.env.REACT_APP_API_URL;

    return (
        <>
            <Navbar />
            {/* Search UI */}
            <div className='justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'>
                <input
                    type='text'
                    placeholder='Search by passport number'
                    onChange={handleSearchChange}
                    className='px-4 py-2 text-base border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 w-64'
                />
            </div>

            {/* Data Display */}
            <section className="pb-10 bg-blueGray-200 -mt-auto">
               <div className="container px-4 mx-auto">
                 <div className="flex flex-wrap">
                        {filteredData.map((passport, index) => (
                            <div className="w-full px-4 text-center md:w-4/12" key={index}>
                                <div className="relative flex flex-col w-full min-w-0 mb-8 break-words bg-white rounded-lg shadow-lg">
                                    <div className="flex-auto px-4 py-5">
                                        {passport.passport && passport.passport.length > 0 && passport.passport[0].formats &&
                                            <img
                                                className="inline-flex items-center justify-center w-16 h-16 mb-5 text-center text-white rounded-full shadow-lg bg-lightBlue-400"
                                                src={baseUrl + passport.passport[0].formats.thumbnail.url}
                                                alt={passport.passport[0].alternativeText || "Passport"}
                                                style={{ borderRadius: "25px" }}
                                            />
                                        }
                                        <div className="text-xl font-semibold">First Name: {passport.firstName}</div>
                                        <div className="text-xl font-semibold">Middle Name: {passport.middleName}</div>
                                        <div className="text-xl font-semibold">Last Name: {passport.lastName}</div>
                                        <h6 className="text-xl font-semibold">Passport Number: {passport.passportNumber}</h6>
                                        <h6 className="text-xl font-semibold">Role: {passport.passport_type.Rule}</h6>
                                        <h6 className="text-xl font-semibold">Issue: {passport.issue}</h6>
                                        <h6 className="text-xl font-semibold">Expiry: {passport.expire}</h6>
                                        {/* <h6 className="text-xl font-semibold">Created At: {passport.created_at}</h6> */}
                                        {/* <Link to={`/EMCPassportDetails/${passport.id}`} className='text-blue-500 hover:underline'>Read more</Link> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default ArchiveTable;
